import type { User } from '@auth0/auth0-react'
import { Role } from '../Permissions/types/Permissions'

export function getUserRoles(user: User | undefined): Role[] {
  return user?.['http://eigtech.io/claims/roles'] ?? []
}
